import { deepFreeze } from "@tmi/utils/immutability";
import { useLabelService } from "@/composables/label-service";

const labelService = useLabelService();

// Keys must match the column names tmi-services-sentient sends in open_pos_keys / closed_pos_keys (ModelPortfolios/DTOs/MetaData.cs):
// an unmatched key renders a blank header (DP-12, `sec_rs` vs `sector_rs`).
const columnsMap: Map< string, string > = new Map< string, string >();
columnsMap.set( 'symbol', labelService.label( 'lblSymbol' ) );
columnsMap.set( 'sector', labelService.label( 'lblSector' ) );
columnsMap.set( 'opened_stock_price', labelService.label( 'lblStockEntryPrice' ) );
columnsMap.set( 'opened_options_price', labelService.label( 'lblOptionsEntryPrice' ) );
columnsMap.set( 'last_close', labelService.label( 'lblLastClose' ) );
columnsMap.set( 'stance', labelService.label( 'lblStance' ) );
columnsMap.set( 'bpi_status', labelService.label( 'lblBpiStatus' ) );
columnsMap.set( 'sector_rs', labelService.label( 'lblSectorRS' ) );
columnsMap.set( 'peer_rs', labelService.label( 'lblPeerRS' ) );
columnsMap.set( 'mkt_rs', labelService.label( 'lblMarketRS' ) );
columnsMap.set( 'current_stock_gains', labelService.label( 'lblCurrentStockGains' ) );
columnsMap.set( 'current_options_gains', labelService.label( 'lblCurrentOptionsGains' ) );
columnsMap.set( 'initiated', labelService.label( 'lblInitiated' ) );
columnsMap.set( 'last_updated', labelService.label( 'lblLastUpdated' ) );
columnsMap.set( 'last_check_point', labelService.label( 'lblMostRecentCheckPoint' ) );
columnsMap.set( 'price_target', labelService.label( 'lblPriceTarget' ) );
columnsMap.set( 'stop_loss', labelService.label( 'lblStopLoss' ) );
columnsMap.set( 'm_e_gain', labelService.label( 'lblMonthEndGains' ) );
columnsMap.set( 'max_gain', labelService.label( 'lblMaxGains' ) );
columnsMap.set( 'option_expiration_month', labelService.label( 'lblOptionExpirationMonth' ) );
columnsMap.set( 'option_strike', labelService.label( 'lblOptionStrike' ) );
columnsMap.set( 'actions', labelService.label( 'lblActions' ) );
columnsMap.set( 'closed', labelService.label( 'lblExited' ) );
columnsMap.set( 'closed_stock_price', labelService.label( 'lblStockExitPrice' ) );
columnsMap.set( 'closed_options_price', labelService.label( 'lblOptionExitPrice' ) );
columnsMap.set( 'buy_under', labelService.label( 'lblBuyUnder' ) );
columnsMap.set( 'stock_gains', labelService.label( 'lblStockGains' ) );
columnsMap.set( 'options_gains', labelService.label( 'lblOptionGains' ) );
columnsMap.set( 'note', labelService.label( 'lblWeighting' ) );

const modelPortfolioAvailableColumns: Readonly< Map< string, string > >  = deepFreeze( columnsMap );
export { modelPortfolioAvailableColumns };
